'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.default = rootSaga;

var _effects = require('redux-saga/effects');

var _insurances = require('./insurances');

var _insurances2 = _interopRequireDefault(_insurances);

var _relativeTypes = require('./relativeTypes');

var _relativeTypes2 = _interopRequireDefault(_relativeTypes);

var _roles = require('./roles');

var _roles2 = _interopRequireDefault(_roles);

var _user = require('./user');

var _user2 = _interopRequireDefault(_user);

var _clinics = require('./clinics');

var _clinics2 = _interopRequireDefault(_clinics);

var _room = require('./room');

var _room2 = _interopRequireDefault(_room);

var _appointments = require('./appointments');

var _appointments2 = _interopRequireDefault(_appointments);

var _confirmations = require('./confirmations');

var _confirmations2 = _interopRequireDefault(_confirmations);

var _workingHours = require('./workingHours');

var _workingHours2 = _interopRequireDefault(_workingHours);

var _patients = require('./patients');

var _patients2 = _interopRequireDefault(_patients);

var _vacations = require('./vacations');

var _vacations2 = _interopRequireDefault(_vacations);

var _country = require('./country');

var _country2 = _interopRequireDefault(_country);

var _schedules = require('./schedules');

var _schedules2 = _interopRequireDefault(_schedules);

var _payment = require('./payment');

var _payment2 = _interopRequireDefault(_payment);

var _specialties = require('./specialties');

var _specialties2 = _interopRequireDefault(_specialties);

var _prefixTitles = require('./prefixTitles');

var _prefixTitles2 = _interopRequireDefault(_prefixTitles);

var _professionalTitles = require('./professionalTitles');

var _professionalTitles2 = _interopRequireDefault(_professionalTitles);

var _entities = require('./entities');

var _entities2 = _interopRequireDefault(_entities);

var _services = require('./services');

var _services2 = _interopRequireDefault(_services);

var _aman = require('./aman');

var _aman2 = _interopRequireDefault(_aman);

var _assistant = require('./assistant');

var _assistant2 = _interopRequireDefault(_assistant);

var _citiesAndAreas = require('./citiesAndAreas');

var _citiesAndAreas2 = _interopRequireDefault(_citiesAndAreas);

var _accounts = require('./accounts');

var _accounts2 = _interopRequireDefault(_accounts);

var _Pharma = require('./Pharma');

var _Pharma2 = _interopRequireDefault(_Pharma);

var _bid = require('./bid');

var _bid2 = _interopRequireDefault(_bid);

var _activities = require('./activities');

var _activities2 = _interopRequireDefault(_activities);

var _servicesAndOperations = require('./servicesAndOperations');

var _servicesAndOperations2 = _interopRequireDefault(_servicesAndOperations);

var _doctor = require('./doctor');

var _doctor2 = _interopRequireDefault(_doctor);

var _invoices = require('./invoices');

var _invoices2 = _interopRequireDefault(_invoices);

var _plans = require('./plans');

var _plans2 = _interopRequireDefault(_plans);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga);

var sagas = [_plans2.default, _invoices2.default, _doctor2.default, _servicesAndOperations2.default, _activities2.default, _bid2.default, _insurances2.default, _relativeTypes2.default, _roles2.default, _user2.default, _workingHours2.default, _clinics2.default, _room2.default, _appointments2.default, _confirmations2.default, _patients2.default, _vacations2.default, _country2.default, _schedules2.default, _payment2.default, _specialties2.default, _prefixTitles2.default, _professionalTitles2.default, _entities2.default, _services2.default, _aman2.default, _assistant2.default, _citiesAndAreas2.default, _accounts2.default, _Pharma2.default];

function rootSaga() {
  return _regenerator2.default.wrap(function rootSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return sagas.map(function (saga) {
            return (0, _effects.fork)(saga);
          });

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}
module.exports = exports['default'];